import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    ViewChild,
} from '@angular/core';

@Component({
    selector: 'app-editor-observaciones',
    templateUrl: './editor-observaciones.component.html',
    styleUrl: './editor-observaciones.component.scss',
})
export class EditorObservacionesComponent {
    @Input() observaciones: string = '';
    @Output() observacionesChange = new EventEmitter<string>();

    @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

    private quillEditor: any;

    onEditorInit(event: any) {
        this.quillEditor = event.editor;

        const toolbar = this.quillEditor.getModule('toolbar');
        toolbar.addHandler('image', () => {
            this.fileInput.nativeElement.click();
        });
    }

    emitirTexto() {
        this.observacionesChange.emit(this.observaciones);
    }

    onImagenSeleccionada(event: Event) {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files[0]) {
            const file = input.files[0];
            const reader = new FileReader();

            reader.onload = () => {
                const base64 = reader.result as string;
                const range = this.quillEditor.getSelection(true);
                this.quillEditor.insertEmbed(range.index, 'image', base64);
                this.quillEditor.setSelection(range.index + 1);

                this.observaciones = this.quillEditor.root.innerHTML;
                this.observacionesChange.emit(this.observaciones);
            };

            reader.readAsDataURL(file);
            input.value = '';
        }
    }
}
